export const GET_ALL_PROJECTS = 'GET_ALL_PROJECTS'
export const SET_LOADING = 'SET_LOADING'
export const IS_MY_PROJECTS = 'IS_MY_PROJECTS'
export const IS_INCLUDE_ARCHIVED = 'IS_INCLUDE_ARCHIVED'
export const SET_PROJECT_DATA = 'SET_PROJECT_DATA'
export const SET_PROJECT_DETAILS = 'SET_PROJECT_DETAILS'
export const SET_PROJECT_DETAILS_LOADING = 'SET_PROJECT_DETAILS_LOADING'
export const SET_TAB_CONTENT = 'SET_TAB_CONTENT'
export const SET_PROJECT_SEARCH_TEXT = 'SET_PROJECT_SEARCH_TEXT'
export const SET_PROJECT_LOADING = 'SET_PROJECT_LOADING'
export const SET_CUSTOM_COLUMNS_LIST = 'SET_CUSTOM_COLUMNS_LIST'
export const SET_PROJECT_SEARCH_TYPE = 'SET_PROJECT_SEARCH_TYPE'
export const SET_WORKFLOW_ITEMS = 'SET_WORKFLOW_ITEMS'
export const SET_REPURPOSE_PACKAGING_ASSETS_LOADING =
  'SET_REPURPOSE_PACKAGING_ASSETS_LOADING'
export const RESET_PROJECT_DATA = 'RESET_PROJECT_DATA'
export const SET_PROJECT_METRIC_DATA = 'SET_PROJECT_METRIC_DATA'
export const RESET_PROJECT_METRIC_DATA = 'RESET_PROJECT_METRIC_DATA'
